/** @deprecated Use {@link https://dev.azure.com/oriflame/FrontendPlatform/_git/toolbox?path=/packages/auth | @ori/auth} */
export const NOT_LOGGED_IN_USER_ID = -1;

/** @deprecated Use {@link https://dev.azure.com/oriflame/FrontendPlatform/_git/toolbox?path=/packages/configuration-manager | @ori/configuration-manager} */
export const ENVIRONMENT_CODES = ['dev', 'uat', 'pat', 'stg', 'live'];
//# sourceMappingURL=constants.js.map